<script lang="ts">
    import CN from "classnames";
    import { Observable, fromEvent } from "rxjs";
    import { filter, map } from "rxjs/operators";
    import { onMount } from "svelte";

    let className: string | undefined = undefined;
    export { className as class };

    export let visible = false;
    export let topShadow = false;
    export let bottomShadow = false;
    export let isOverScrollBehavior = false;

    let containerRef: HTMLElement | null = null;
    let scrollPosition$: Observable<number>;

    onMount(() => {
        if (containerRef) {
            scrollPosition$ = fromEvent(containerRef, "scroll").pipe(
                map((event) => event.currentTarget),
                filter((target): target is HTMLElement => !!target),
                map((element) => element.scrollTop)
            );
        }
    });
</script>

<div
    class={CN("gw-scrollable", className, {
        "gw-scrollable--visible": visible,
        "gw-scrollable--scrolled": topShadow && $scrollPosition$ > 0,
        "gw-scrollable--top-shadow": topShadow && $scrollPosition$,
        "gw-scrollable--bottom-shadow":
            bottomShadow && (!$scrollPosition$ || $scrollPosition$ <= 0),
        "gw-scrollable--overscroll-behavior": isOverScrollBehavior,
    })}
    on:scroll
    bind:this={containerRef}
>
    <slot />
</div>

<style lang="postcss">
    .gw-scrollable {
        position: relative;
        height: 100%;
        overflow-y: auto;
        overflow-x: hidden;
        -ms-overflow-style: none; /* for Internet Explorer, Edge */
        scrollbar-width: none; /* for Firefox */

        &--top-shadow::before {
            content: "";
            display: block;
            position: sticky;
            top: 0;
            left: 0;
            height: 40px;
            width: 100%;
            opacity: 0;
            background: linear-gradient(
                0deg,
                rgba(255, 255, 255, 0) -137.88%,
                #fff 100%
            );
            transition: opacity 0.3s linear;
            pointer-events: none;
            z-index: 1;
        }

        &--bottom-shadow::after {
            content: "";
            position: absolute;
            bottom: 0;
            z-index: 1;
            left: 0;
            width: 100%;
            height: 40px;
            display: block;
            opacity: 0.7;
            background: linear-gradient(
                180deg,
                rgba(255, 255, 255, 0) -137.88%,
                #fff 100%
            );
            background-repeat: no-repeat;
        }

        &--scrolled::before {
            opacity: 0.7;
        }

        &::-webkit-scrollbar {
            display: none; /* for Chrome, Safari, and Opera */
        }
        &--visible {
            scrollbar-width: thin; /* for Firefox */
            scrollbar-color: hsl(var(--gw-rd-main-color) / 0.6)
                rgba(11, 30, 71, 0.1); /* for Firefox */
            &::-webkit-scrollbar {
                display: block;
                width: 6px;
            }
            &::-webkit-scrollbar-track {
                background: rgba(11, 30, 71, 0.1);
            }
            &::-webkit-scrollbar-thumb {
                background: hsl(var(--gw-rd-main-color) / 0.6);
                border-radius: var(--gw-rd-border-radius-base);
            }
        }

        &--overscroll-behavior {
            overscroll-behavior: contain;
        }
    }
</style>
